import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedNumber, FormattedDate, FormattedTime } from "react-intl";
export const getNumberRenderer = (column, format) => (row) => {
    let value = column.field && row[column.field];
    if (Number.isNaN(Number(value)))
        return null;
    if (column.type === "percent")
        value = value / 100;
    if (column.round)
        value = Math.round(value);
    return (_jsx(FormattedNumber, { value: value, format: format, ...column.formatOptions }));
};
export const getDateRenderer = (column, format) => (row) => {
    let value = column.field && row[column.field];
    return value ? (_jsx(FormattedDate, { value: value, format: format, ...column.formatOptions })) : null;
};
export const getTimeRenderer = (column, format) => (row) => {
    let value = column.field && row[column.field];
    return !value ? null : (_jsx(FormattedTime, { value: value, format: format, ...column.formatOptions }));
};
//# sourceMappingURL=cellRenderers.js.map